import { getStore } from 'core_main/store';
import { debug, LogLabel } from 'globals/errors';
import {
  createConversationChannelGroupString,
  createMetaCustomerChannelString,
} from './channelName';
import { getConversationPubNub, getMetaPubNub } from './instance';

export interface ResubscribeConversationChannelGroupOptions {
  customerId?: string;
  orgId?: string;
}

/**
 * Re-issues conversation channel-group + meta customer subscribe.
 * Used after session create (group just gained channels) and when recovering
 * from PubNub's empty channel-group 400.
 */
export const resubscribeConversationChannelGroup = (
  options: ResubscribeConversationChannelGroupOptions = {},
): void => {
  const store = getStore();
  const customerId = options.customerId || store.customerId;
  const orgId = options.orgId || store.orgId;

  if (!customerId || !orgId) {
    debug({
      message:
        'Skipping channel-group resubscribe: missing customerId or orgId',
      labels: [LogLabel.PUBNUB_RECOVERY],
    });
    return;
  }

  const channelGroupString = createConversationChannelGroupString(
    customerId,
    orgId,
  );
  const customerMetaChannel = createMetaCustomerChannelString(
    customerId,
    orgId,
  );

  debug({
    message: `Resubscribing conversation channel group ${channelGroupString}`,
    labels: [LogLabel.PUBNUB_RECOVERY],
  });

  getConversationPubNub(customerId)?.instance?.subscribe({
    channelGroups: [channelGroupString],
  });
  getMetaPubNub(customerId)?.instance?.subscribe({
    channels: [customerMetaChannel],
  });
};
